<template>
  <section class="hero-section" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <div class="hero-overlay"></div>
    <div class="container hero-content">
      <h1>{{ $t('hero.title') }}</h1>
      <p>{{ $t('hero.subtitle') }}</p>
      <button class="cta-button">{{ $t('hero.cta') }}</button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      // Replace with your actual hero image URL or use a local image
      // For local: backgroundImage: require('@/assets/hero-image.jpg')
      backgroundImage: require('@/assets/fm.webp'),
    };
  },
};
</script>

<style scoped>
.hero-section {
  height: 70vh; /* Adjust height as needed, e.g., 500px, 60vh */
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  padding: 0 20px; /* Add some padding for text on smaller screens */
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45); /* Dark overlay for text readability, adjust opacity as needed */
}

.container.hero-content {
  position: relative; /* To sit on top of overlay */
  z-index: 1;
  max-width: 800px; /* Limit width of content for better readability */
}

h1 {
  font-size: 3em; /* Adjust as needed */
  margin-bottom: 20px;
  font-weight: bold;
  line-height: 1.2;
}

p {
  font-size: 1.2em; /* Adjust as needed */
  margin-bottom: 30px;
  line-height: 1.6;
}

.cta-button {
  background-color: #007bff; /* UAMAX blue, or your primary brand color */
  color: white;
  padding: 15px 35px; /* Slightly larger padding */
  border: none;
  border-radius: 5px;
  font-size: 1.1em;
  font-weight: 500; /* Slightly bolder */
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  text-transform: uppercase; /* Optional: for a more "button" feel */
  letter-spacing: 0.5px; /* Optional */
}

.cta-button:hover {
  background-color: #0056b3; /* Darker shade on hover */
  transform: translateY(-2px); /* Slight lift on hover */
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .hero-section {
    height: 60vh; /* Adjust height for smaller screens */
  }
  h1 {
    font-size: 2.2em;
  }
  p {
    font-size: 1.1em;
  }
  .cta-button {
    padding: 12px 28px;
    font-size: 1em;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 1.8em;
  }
  p {
    font-size: 1em;
  }
  .cta-button {
    padding: 10px 20px;
  }
}
</style>